import { parseJson } from 'legacy/lut/classes/helpers/JsonHelper'
import { EltType } from 'legacy/lut/classes/models/partner360/ELT/EltType'
import { IELTData, IELTDataSettings } from 'legacy/lut/classes/models/partner360/ELT/IELTData'
import { TEltFormData } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { defaultActualValueTypes } from 'legacy/lut/components/widgets/public/partner360/ELT/configs'

import { fetchELTPopulatedData } from '../../api/eltData/fetchELTPopulatedData'
import { IForceUpdateData } from '../../models/IForceUpdateData'
import { IPartnerGroupAdditionalInfo } from '../../models/IPartnerGroupAdditionalInfo'
import { INITIAL_POPULATED_DATA } from '../../models/PopulatedData'
import { getInitialData } from '../getInitialData'

import { getCompanyName } from './getCompanyName'
import { getFinancialDataHelper } from './getFinancialDataHelper'

interface IGetBasicEltData {
  item: IELTData
  partnerId: string
  partnerGroupData: IPartnerGroupAdditionalInfo | null
  fYear: number
  fQuarter: number
  isRollup: number
}

export const getBasicEltData = async ({
  item,
  partnerGroupData,
  partnerId,
  fQuarter,
  fYear,
  isRollup,
}: IGetBasicEltData) => {
  const companyName = await getCompanyName({ partnerId, data: item })

  const eltType = item.EltType || EltType.DocJanuary26

  const financialData = await getFinancialDataHelper({
    partnerId,
    fYear: fYear,
    groupId: partnerGroupData?.groupId || null,
    eltType,
    isRollup: isRollup,
  })

  const populatedData = await fetchELTPopulatedData({
    partnerId,
    groupId: partnerGroupData?.groupId,
    fYear,
    eltType,
  })

  const parsedData = item.FormData
    ? parseJson<TEltFormData>(
        item.FormData?.replace(/class="\\&quot;editor-block\\&quot;"/g, '')?.replace(
          /class="\\&quot;editor-block-content\\&quot;"/g,
          ''
        ) //remove non safe json data
      )
    : null

  const actualValueTypes = financialData?.AVTSettings?.ActualsValueTypes || defaultActualValueTypes
  const itemSettings: IELTDataSettings = {
    NetNdp: financialData?.AVTSettings?.AVTDefault || defaultActualValueTypes[0],
    ActualsValueTypes: actualValueTypes,
    DisplayWarningForTypes: financialData?.AVTSettings?.DisplayWarningForTypes || [],
    WarningKey: financialData?.AVTSettings?.WarningKey || '',
  }

  const initializationFormData = getInitialData({
    formData: parsedData,
    financialData,
    partnerGroupData,
    companyName,
    populatedData: populatedData || INITIAL_POPULATED_DATA,
    itemEntryId: item.EntryId,
    eltType,
    actualValueTypes: actualValueTypes,
    isRollup,
  })

  const itemPrefillData: Partial<IELTData> = {
    PartnerName: partnerGroupData?.groupName || companyName,
    PartnerId: partnerGroupData?.groupId ? null : partnerId,
    GroupId: partnerGroupData?.groupId ? partnerGroupData.groupId : null,
    FYear: fYear,
    FQuarter: fQuarter,
    EltType: eltType,
    Settings: JSON.stringify(itemSettings),
  }

  const forceUpdateData: IForceUpdateData = {
    revenue: {
      SellThruDesc: financialData?.SellThruDesc || 'SellThru',
      SellToDesc: financialData?.SellToDesc || 'SellTo',
    },
  }

  if (parsedData) {
    return {
      item: {
        ...item,
        ...itemPrefillData,
      },
      formData: parsedData,
      forceUpdateData,
    }
  }

  return {
    item: {
      ...item,
      ...itemPrefillData,
    },
    formData: initializationFormData,
    forceUpdateData,
  }
}
